import { lazyNamed } from 'src/utils/lazyNamed';
import { CompanyFloorRuleFormSearchKey } from './pages/FloorRuleForm/types';
import TagDetails from './pages/TagDetails';
import { PlacementSearchKey } from './pages/TagDetails/containers/Placement/types';
import { TagDetailsTab } from './pages/TagDetails/types';
import { TagFormSearchKey } from './pages/TagForm/types';

export { TagDetailsTab, TagFormSearchKey, PlacementSearchKey, CompanyFloorRuleFormSearchKey };

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  TagsList: lazyNamed(() => import('./pages/TagsList'), 'TagsList'),
  TagForm: lazyNamed(() => import('./pages/TagForm'), 'TagForm'),
  TagDetails,
  RawScriptsList: lazyNamed(() => import('./pages/RawScriptsList'), 'RawScriptsList'),
  FloorRulesList: lazyNamed(() => import('./pages/FloorRulesList'), 'FloorRulesList'),
  FloorRuleForm: lazyNamed(() => import('./pages/FloorRuleForm'), 'FloorRuleForm'),
  BiddersConfigsList: lazyNamed(() => import('./pages/BiddersConfigsList'), 'BiddersConfigsList'),
  BidderConfigForm: lazyNamed(() => import('./pages/BidderConfigForm'), 'BidderConfigForm'),
};
